import {
  fetchSufficitBrowserExtensionOptions,
  fetchSufficitExtensionOptions,
  fetchSufficitState,
} from '../api/sufficit';

const isSufficitInbox = inbox => {
  return (
    inbox?.channel_type === 'Channel::Sip' &&
    inbox?.additional_attributes?.integration === 'sufficit'
  );
};

export const buildSufficitSipExtensionProvider = payload => {
  if (!isSufficitInbox(payload?.inbox)) {
    return payload;
  }

  const resolveRemoteConfig = async ({ accountId, inbox }) => {
    const sufficitConfig = inbox?.additional_attributes?.sufficit || {};
    const authMode = sufficitConfig.auth_mode;
    const siteUrl = sufficitConfig.site_url;
    const extensionsEndpointTemplate =
      sufficitConfig.extensions_endpoint_template;

    if (siteUrl && extensionsEndpointTemplate) {
      return {
        authMode,
        siteUrl,
        extensionsEndpointTemplate,
      };
    }

    const response = await fetchSufficitState(accountId);
    return {
      authMode: authMode || response.data?.hook?.auth_mode,
      siteUrl: siteUrl || response.data?.hook?.site_url,
      extensionsEndpointTemplate:
        extensionsEndpointTemplate ||
        response.data?.hook?.extensions_endpoint_template,
    };
  };

  return {
    ...payload,
    provider: {
      id: 'sufficit',
      label: 'Sufficit extension',
      mode: 'managed',
      async loadAgentOptions({ accountId, inbox, agent }) {
        const remoteConfig = await resolveRemoteConfig({ accountId, inbox });

        if (remoteConfig.authMode === 'browser_session') {
          return fetchSufficitBrowserExtensionOptions({
            siteUrl: remoteConfig.siteUrl,
            contextId: inbox?.additional_attributes?.sufficit?.context_id,
            extensionsEndpointTemplate: remoteConfig.extensionsEndpointTemplate,
            agent,
          });
        }

        const response = await fetchSufficitExtensionOptions(
          accountId,
          inbox.id,
          agent.id
        );

        return response.data?.options || [];
      },
      applySelection({ option }) {
        if (!option) {
          return {};
        }

        return {
          provider_selection: option.value,
          extension: option.extension || option.value || '',
          password: option.password || '',
          display_name: option.display_name || '',
        };
      },
      getSelectionValue({ draft }) {
        return draft?.provider_selection || draft?.extension || null;
      },
    },
  };
};
